'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  為了傳入 props 進 Login，要用 render，不能用 component
 *  不然每次都會重新 mount Login
 *
 *  Do not support React Router's `render` and `children`
 *  要用 render 就自己寫就好
 *  children 跟 props.children 會衝突
 *  因為 RouteWithProps 可以傳 children element
 *  但 React Router 好像不行
 */
function RouteWithProps(props) {
  var RenderComponent = props.component,
      children = props.children,
      path = props.path,
      exact = props.exact,
      strict = props.strict,
      _props$props = props.props,
      passing = _props$props === undefined ? {} : _props$props;


  return _react2.default.createElement(_reactRouterDom.Route, {
    path: path,
    exact: exact,
    strict: strict,
    render: function render(routeProps) {
      return (
        // ISSUE wrap route props `route={routeProps}` to avoid confilct?
        _react2.default.createElement(
          RenderComponent,
          _extends({}, passing, routeProps),
          children
        )
      );
    }
  });
}

var oneOfType = _propTypes2.default.oneOfType,
    arrayOf = _propTypes2.default.arrayOf,
    instanceOf = _propTypes2.default.instanceOf,
    element = _propTypes2.default.element,
    func = _propTypes2.default.func,
    string = _propTypes2.default.string,
    bool = _propTypes2.default.bool,
    object = _propTypes2.default.object;


RouteWithProps.propTypes = {
  component: oneOfType([func, instanceOf(_react2.default.Component)]),
  children: oneOfType([arrayOf(element), element]),
  path: string,
  exact: bool,
  strict: bool,
  props: object
};

exports.default = RouteWithProps;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/RouteWithProps.js
// module id = 1040
// module chunks = 0